export default __webpack_public_path__ + "images/42906f8a0dcde0384a5b9e13bfcd233a.jpg";